import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Rice.css";

export default function Rice() {
  const riceProducts = [
    {
      id: 1,
      name: "1121 WHITE SELLA BASMATI RICE",
      image: "/assets/img/Rices/1121-WHITE-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in premium hotels and restaurants.",
            "Perfect for biryani and pulao preparations.",
            "Widely exported across international markets.",
            "Preferred for long grain and aromatic dishes.",
          ],
        },
      ],
    },

    {
      id: 2,
      name: "1121 GOLDEN SELLA BASMATI RICE",
      image: "/assets/img/Rices/1121-GOLDEN-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in catering and food industries.",
            "Ideal for traditional Indian cuisine.",
            "Popular in export-quality rice packaging.",
            "Suitable for bulk cooking applications.",
          ],
        },
      ],
    },

    {
      id: 3,
      name: "1121 STEAM BASMATI RICE",
      image: "/assets/img/Rices/1121-STEAM-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in healthy meal preparations.",
            "Preferred in restaurants and homes.",
            "Suitable for export and wholesale supply.",
            "Ideal for fluffy rice dishes.",
          ],
        },
      ],
    },

    {
      id: 4,
      name: "1401 WHITE SELLA BASMATI RICE",
      image: "/assets/img/Rices/1401-WHITE-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.70 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in food service industries.",
            "Perfect for daily and commercial cooking.",
            "Popular in Middle East export markets.",
            "Suitable for long grain rice recipes.",
          ],
        },
      ],
    },

    {
      id: 5,
      name: "1401 STEAM BASMATI RICE",
      image: "/assets/img/Rices/1401-STEAM-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.70 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in premium rice dishes.",
            "Applied in hotels and catering businesses.",
            "Ideal for healthy cooking applications.",
            "Preferred for export packaging.",
          ],
        },
      ],
    },

    {
      id: 6,
      name: "1509 WHITE SELLA BASMATI RICE",
      image: "/assets/img/Rices/1509-WHITE-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in biryani and pulao preparation.",
            "Popular in restaurants and catering services.",
            "Exported globally for premium quality.",
            "Preferred for long grain texture.",
          ],
        },
      ],
    },

    {
      id: 7,
      name: "1509 GOLDEN SELLA BASMATI RICE",
      image: "/assets/img/Rices/1509-GOLDEN-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in food export industries.",
            "Suitable for traditional rice recipes.",
            "Preferred for rich aroma and taste.",
            "Used in large-scale cooking industries.",
          ],
        },
      ],
    },

    {
      id: 8,
      name: "1509 STEAM BASMATI RICE",
      image: "/assets/img/Rices/1509-STEAM-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 8.35 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in homes and restaurants.",
            "Suitable for healthy food preparation.",
            "Preferred in export and wholesale markets.",
            "Ideal for steamed rice dishes.",
          ],
        },
      ],
    },

    {
      id: 9,
      name: "PUSA WHITE SELLA BASMATI RICE",
      image: "/assets/img/Rices/PUSA-WHITE-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.60 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in restaurants and hotels.",
            "Ideal for Indian and Middle Eastern dishes.",
            "Popular in export-quality packaging.",
            "Suitable for commercial cooking.",
          ],
        },
      ],
    },

    {
      id: 10,
      name: "PUSA GOLDEN SELLA BASMATI RICE",
      image: "/assets/img/Rices/PUSA-GOLDEN-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.60 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in traditional rice recipes.",
            "Preferred for premium catering services.",
            "Popular in export markets.",
            "Suitable for aromatic rice dishes.",
          ],
        },
      ],
    },

    {
      id: 11,
      name: "PUSA STEAM BASMATI RICE",
      image: "/assets/img/Rices/PUSA-STEAM-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.60 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in healthy meal preparations.",
            "Ideal for homes and food chains.",
            "Suitable for export packaging.",
            "Preferred for fluffy rice texture.",
          ],
        },
      ],
    },

    {
      id: 12,
      name: "SUGANDHA WHITE SELLA BASMATI RICE",
      image: "/assets/img/Rices/SUGANDHA-WHITE-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.80-7.90 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in hotels and catering industries.",
            "Ideal for aromatic rice dishes.",
            "Suitable for export and wholesale supply.",
            "Preferred for long grain cooking.",
          ],
        },
      ],
    },

    {
      id: 13,
      name: "SUGANDHA GOLDEN SELLA BASMATI RICE",
      image: "/assets/img/Rices/SUGANDHA-GOLDEN-SELLA-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.80-7.90 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in premium food services.",
            "Suitable for biryani and pulao.",
            "Popular in export markets.",
            "Preferred for rich aroma and texture.",
          ],
        },
      ],
    },

    {
      id: 14,
      name: "SUGANDHA WHITE STEAM BASMATI RICE",
      image: "/assets/img/Rices/SUGANDHA-WHITE-STEAM-BASMATI-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7.80-7.90 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in healthy rice preparations.",
            "Suitable for restaurants and homes.",
            "Preferred in export packaging.",
            "Ideal for soft and fluffy rice dishes.",
          ],
        },
      ],
    },

    {
      id: 15,
      name: "SHARBATI WHITE SELLA RICE",
      image: "/assets/img/Rices/SHARBATI-WHITE-SELLA-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7-7.10 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in homes and catering services.",
            "Ideal for daily cooking applications.",
            "Suitable for commercial rice supply.",
            "Preferred for economical rice dishes.",
          ],
        },
      ],
    },

    {
      id: 16,
      name: "SHARBATI GOLDEN SELLA RICE",
      image: "/assets/img/Rices/SHARBATI-GOLDEN-SELLA-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7-7.10 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in food industries and hotels.",
            "Suitable for traditional rice dishes.",
            "Preferred for large-scale cooking.",
            "Popular in wholesale supply.",
          ],
        },
      ],
    },

    {
      id: 17,
      name: "SHARBATI WHITE STEAM RICE",
      image: "/assets/img/Rices/SHARBATI-WHITE-STEAM-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 7-7.10 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in healthy food preparation.",
            "Ideal for homes and restaurants.",
            "Suitable for export packaging.",
            "Preferred for soft texture cooking.",
          ],
        },
      ],
    },

    {
      id: 18,
      name: "PR-11/14 WHITE SELLA RICE",
      image: "/assets/img/Rices/PR-1114-WHITE-SELLA-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 6.80 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in commercial cooking industries.",
            "Suitable for economical rice supply.",
            "Applied in hotels and catering businesses.",
            "Popular for bulk export orders.",
          ],
        },
      ],
    },

    {
      id: 19,
      name: "PR-11/14 GOLDEN SELLA RICE",
      image: "/assets/img/Rices/PR-1114-GOLDEN-SELLA-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 6.80 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in catering and food industries.",
            "Suitable for traditional cooking.",
            "Preferred for wholesale distribution.",
            "Ideal for large-scale rice consumption.",
          ],
        },
      ],
    },

    {
      id: 20,
      name: "PR-11/14 STEAM RICE",
      image: "/assets/img/Rices/PR-1114-STEAM-RICE.jpg",
      usage: [
        {
          title: "Rice Specification",
          points: [
            "Length: 6.80 mm",
            "Moisture: 12-13%",
            "Purity: 95%",
            "Broken Ratio: 1%",
          ],
        },
        {
          title: "Where It’s Used",
          points: [
            "Used in homes and restaurants.",
            "Ideal for healthy cooking applications.",
            "Suitable for export packaging.",
            "Preferred for soft cooked rice texture.",
          ],
        },
      ],
    },
  ];

  const defaultImage =
    "https://upload.wikimedia.org/wikipedia/commons/6/6f/Rice_grains.jpg";

  const [selectedProduct, setSelectedProduct] = useState(null);

  const closeModal = () => setSelectedProduct(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumb
        title="Rice"
        backgroundImage="./assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="rice-section">
        <div className="container">
          <h1 className="rice-title">  Basmati Rice Collection</h1>

          <p className="rice-subtitle">
            Trusted global supplier of premium quality rice varieties.
          </p>

          <div className="rice-grid">
            {riceProducts.map((product) => (
              <div className="rice-card" key={product.id}>
                <div className="rice-img-box">
                  <img
                    src={product.image || defaultImage}
                    alt={product.name}
                    onError={(e) => (e.target.src = defaultImage)}
                  />
                </div>

                <div className="rice-info">
                  <h2 className="rice-name">{product.name}</h2>

                  <button
                    className="view-btn"
                    onClick={() => setSelectedProduct(product)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {selectedProduct && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedProduct.image || defaultImage}
                  alt={selectedProduct.name}
                  className="modal-image"
                />

                <h2 className="modal-title">{selectedProduct.name}</h2>

                <div className="usage-section">
                  {selectedProduct.usage.map((section, index) => (
                    <div key={index} className="usage-block">
                      <h3>{section.title}</h3>

                      <ul>
                        {section.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}